import { useState } from "react"
import { IRenda } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Grid, TextField } from "@mui/material"
import { NumberFormatCustom } from "../../../../../../../utils"

export const RecorteRendaMensal = () => {
    // Use State
    const [selectedRendaMensal, setSelectedRendaMensal] = useState<IRenda>({})
    // Hook
    const { setEditRecorteFormFiltros } = useRecortesExtracaoService()
    

    return (
        <>
            <Grid item xs={5.5} my={2} px={2}>
                <TextField
                    value={selectedRendaMensal.min ?? ''}
                    InputProps={{
                        startAdornment: <span style={{
                            marginRight: '5px'
                        }}>R$</span>,
                        inputComponent: NumberFormatCustom,
                    }}
                    onChange={(e) => {
                        const regexValue = e.target.value.replace(/\D/g, '')
                        const updatedMin = regexValue.length === 0 ? undefined : Number(regexValue)
                    
                        const updatedRenda = {
                            ...selectedRendaMensal,
                            min: updatedMin
                        }
                    
                        setSelectedRendaMensal(updatedRenda)
                    
                        // ✅ Atualiza o filtro global
                        setEditRecorteFormFiltros({
                            filtro: 'rendaPresumidaMensal',
                            value: updatedRenda
                        })
                    }}
                    
                    label="Renda mensal mínima"
                    fullWidth
                />
            </Grid>
            <Grid item xs={5.5} my={2} px={2}>
                <TextField
                    value={selectedRendaMensal.max ?? ''}
                    InputProps={{
                        startAdornment: <span style={{
                            marginRight: '5px'
                        }}>R$</span>,
                        inputComponent: NumberFormatCustom,
                    }}
                    onChange={(e) => {
                        const regexValue = e.target.value.replace(/\D/g, '')
                        const updatedMax = regexValue.length === 0 ? undefined : Number(regexValue)
                    
                        const updatedRenda = {
                            ...selectedRendaMensal,
                            max: updatedMax
                        }
                    
                        setSelectedRendaMensal(updatedRenda)
                    
                        // ✅ Atualiza o filtro global
                        setEditRecorteFormFiltros({
                            filtro: 'rendaPresumidaMensal',
                            value: updatedRenda
                        })
                    
                    }}
                    label="Renda mensal máxima"
                    fullWidth
                />
            </Grid>
        </>
    )
}